import {
  SET_ROADMAP_V2_STATE,
  SET_ROADMAP_V2_DATA,
  SET_ROADMAP_V2_STATUS,
  SET_ROADMAP_V2_GOALS,
  SET_ROADMAP_V2_CERTIFICATE,
  SET_ROADMAP_V2_NEXT_GOALS,
  SET_ROADMAP_V2_LOADING,
  SET_ROADMAP_V2_ERROR,
  SET_ROADMAP_V2_UNLOCKED_COURSES,
  SET_ROADMAP_V2_CERTIFIED_ENROLLMENTS,
  RESET_ROADMAP_V2,
} from "../actions/types";

const initialState = {
  heroState: "loading", // "goal_picker" | "upload_cv" | "generating" | "ready" | "in_progress" | "completed" | "loading"
  userFirstName: "",
  roadmap: null,
  status: null,
  goals: { suggested: [], results: [] },
  certificate: null,
  nextGoals: [],
  unlockedCourses: [],
  certifiedEnrollments: [],
  loading: false,
  error: null,
};

export default function roadmapV2Reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ROADMAP_V2_STATE:
      return {
        ...state,
        heroState: action.payload?.hero_state || state.heroState,
        userFirstName: action.payload?.user_first_name !== undefined ? action.payload.user_first_name : state.userFirstName,
        roadmap: action.payload?.roadmap !== undefined ? action.payload.roadmap : state.roadmap,
        error: null,
      };

    case SET_ROADMAP_V2_DATA:
      return {
        ...state,
        roadmap: action.payload,
        error: null,
      };

    case SET_ROADMAP_V2_STATUS:
      return {
        ...state,
        status: action.payload,
      };

    case SET_ROADMAP_V2_GOALS:
      return {
        ...state,
        goals: action.payload,
      };

    case SET_ROADMAP_V2_CERTIFICATE:
      return {
        ...state,
        certificate: action.payload,
      };

    case SET_ROADMAP_V2_NEXT_GOALS:
      return {
        ...state,
        nextGoals: action.payload,
      };

    case SET_ROADMAP_V2_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ROADMAP_V2_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case SET_ROADMAP_V2_UNLOCKED_COURSES:
      return {
        ...state,
        unlockedCourses: Array.isArray(action.payload) ? action.payload : [],
      };

    case SET_ROADMAP_V2_CERTIFIED_ENROLLMENTS:
      return {
        ...state,
        certifiedEnrollments: Array.isArray(action.payload) ? action.payload : [],
      };

    case RESET_ROADMAP_V2:
      return initialState;

    default:
      return state;
  }
}
